import { motion } from "framer-motion";
import Reveal from "@/components/Reveal";
import { useLang } from "@/i18n";

const ABOUT_IMG = "/images/cecile-portrait.jpg";

export default function About() {
  const { t } = useLang();
  return (
    <section id="about" className="mx-auto max-w-7xl px-6 py-24 lg:px-10 lg:py-36" data-testid="about-section">
      <div className="grid grid-cols-1 items-center gap-16 lg:grid-cols-12">
        <Reveal className="lg:col-span-5">
          <div className="relative">
            <motion.div
              whileHover={{ scale: 0.985 }}
              transition={{ duration: 0.6, ease: [0.16, 1, 0.3, 1] }}
              className="overflow-hidden rounded-[2rem] rounded-tr-[10rem] border border-forest/10"
            >
              <img
                src={ABOUT_IMG}
                alt="Cécile DC Kinnunen, sophrologue et praticienne Reiki"
                className="aspect-[4/5] w-full object-cover transition-transform duration-700 hover:scale-105"
                data-testid="about-image"
              />
            </motion.div>
            <div className="absolute -bottom-6 -right-4 rounded-full border border-forest/10 bg-peach px-6 py-3 text-xs font-semibold uppercase tracking-[0.2em] text-forest shadow-[0_20px_40px_-15px_rgba(44,53,40,0.15)] md:-right-8">
              EN · FR
            </div>
          </div>
        </Reveal>

        <div className="lg:col-span-6 lg:col-start-7">
          <Reveal>
            <p className="mb-6 text-xs font-semibold uppercase tracking-[0.3em] text-stone">{t.about.eyebrow}</p>
            <h2 className="font-serif text-4xl leading-tight tracking-tight md:text-5xl lg:text-6xl">
              {t.about.h2a}<em className="italic font-light text-moss">{t.about.h2b}</em>
            </h2>
          </Reveal>
          <Reveal delay={0.15}>
            <p className="mt-8 text-base leading-relaxed text-moss md:text-lg">{t.about.p1}</p>
            <p className="mt-5 text-base leading-relaxed text-moss md:text-lg">{t.about.p2}</p>
            <p className="mt-5 text-base leading-relaxed text-moss md:text-lg">{t.about.p3}</p>
          </Reveal>
          <Reveal delay={0.25}>
            <div className="mt-10 flex flex-wrap gap-3">
              {t.about.chips.map((chip) => (
                <span
                  key={chip}
                  className="rounded-full border border-forest/15 px-5 py-2 text-xs font-semibold uppercase tracking-[0.15em] text-moss transition-colors duration-300 hover:bg-sage"
                >
                  {chip}
                </span>
              ))}
            </div>
          </Reveal>
        </div>
      </div>
    </section>
  );
}
